import { NavLink } from "react-router-dom";
import { TiContacts } from "react-icons/ti";
import { LuSettings2 } from "react-icons/lu";
import "../../transferir/pagina-ted/styles.css";
import { PageHeader } from "../../../page-header";

const PaginaPixParcelado = () => {

  return (
    <div className="pagina-ted-container">
      <div className="pagina-ted-header">
        <PageHeader title="Pix Parcelado" pages={[{ name: 'Pix', link: "" }]} />
      </div>

      <div className="pagina-ted-content">
        <div className="pagina-ted-content-actions">
          <button disabled title="Em Breve" className="btn-contatos-disabled">
            <TiContacts size={16} />
            Contatos
          </button>

          <NavLink
            to="/pagina-pix-parcelado-pagar"
            className="content-actions-button-red"
          >
            Novo Parcelamento
          </NavLink>

          <NavLink 
            to={"/pix-contratos"} 
            className={"btn-contatos"}
          >
            <LuSettings2 size={16} />
            Meus Pix Parcelados
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default PaginaPixParcelado;
